import { escapeHtml } from '../inventoree/format'

/**
 * Gruparea din inventoree/devices/others/initialEvents.php.
 */

const FIRST = ['Processors', 'Memory', 'Disks', 'Motherboards', 'Network Adapters', 'Video Cards', 'Graphics']

const COMPONENT = /Component\s*<strong>(.*?)<\/strong>\s*-\s*<strong>(.*?)<\/strong>/i
const APPLICATION = /Application\s*<strong>(.*?)<\/strong>(?:\s*version\s*<strong>(.*?)<\/strong>)?/i

export function groupInitialEvents(events: { message: string }[]): string {
  const groups = new Map<string, { name: string; critical: boolean }[]>()
  const plain: string[] = []

  for (const row of events) {
    const message = String(row.message ?? '')
    const critical = message.startsWith('[Critical]')
    const component = message.match(COMPONENT)
    if (component) {
      const type = component[1]!.replace(/<[^>]+>/g, '').trim()
      const name = component[2]!.replace(/<[^>]+>/g, '').trim()
      const list = groups.get(type) ?? []
      list.push({ name, critical })
      groups.set(type, list)
      continue
    }
    const app = message.match(APPLICATION)
    if (app) {
      const name = app[1]!.replace(/<[^>]+>/g, '').trim() + (app[2] && app[2] !== '' ? ' ' + app[2].replace(/<[^>]+>/g, '').trim() : '')
      const list = groups.get('Applications') ?? []
      list.push({ name, critical })
      groups.set('Applications', list)
      continue
    }
    plain.push(message)
  }

  const types = [...groups.keys()].sort((a, b) => {
    const ia = FIRST.indexOf(a)
    const ib = FIRST.indexOf(b)
    const na = ia === -1 ? 999 : ia
    const nb = ib === -1 ? 999 : ib
    return na === nb ? a.localeCompare(b) : na - nb
  })

  let html = '<div class="ev-initial-groups">'
  for (const type of types) {
    const items = groups.get(type) ?? []
    html += `<div class="ev-initial-group"><div class="ev-initial-type">${escapeHtml(type)}`
      + `<span class="ev-initial-count">${items.length}</span></div><ul class="ev-initial-list">`
    for (const item of items) {
      html += `<li${item.critical ? ' class="ev-initial-critical" title="Critical component"' : ''}>`
        + `${escapeHtml(item.name !== '' ? item.name : '(unnamed)')}</li>`
    }
    html += '</ul></div>'
  }
  if (plain.length) {
    html += '<ul class="ev-initial-list">'
    for (const message of plain) html += `<li>${message}</li>`
    html += '</ul>'
  }
  if (types.length === 0 && plain.length === 0) {
    html += '<ul class="ev-initial-list"><li class="ev-initial-empty">Nothing recorded.</li></ul>'
  }
  html += '</div>'
  return html
}
